
export { copyText, escapeContent, encodeContent, upload, getByteLength }

import { notify } from './context'
import * as qiniu from 'qiniu-js'


function getByteLength(s) {
  let len = 0
  for (let i = 0; i < s.length; i++) {
    let sc = s.charCodeAt(i)
    len += (sc.toString(16).length)/2
  }
  return parseInt(len)
}


function upload(file, key, token, complete) {    
  const observable = qiniu.upload(file, key, token, {}, {useCdnDomain:true}) 
  observable.subscribe({
    next: null,
    error: (err) => {
      notify('上传出错' + err.name + err.message)
    },
    complete: complete,
  })
}

function copyText(text) {
  var tempInput = document.createElement("textarea")
  tempInput.value = text
  document.body.appendChild(tempInput)
  tempInput.select()
  document.execCommand('copy')
  document.body.removeChild(tempInput)
}

function escapeContent(content) {
  let s = ''
  let i = 0
  let inCode = false
  while (i < content.length) {
    let c = content[i]
    i += 1

    if (c == '`' && s.endsWith('``')) {
      inCode = !inCode
      s += c
    } else if (inCode) {
      s += c
    } else if (c == '&') {
      s += '&amp;'
    } else if (c == '<') {
      s += '&lt;'
    } else if (c == '>') {
      s += '&gt;'
    } else {
      s += c
    }
  }
  return s
}

function encodeContent(content) {
  let inCode = false
  let inCodeLang = false
  let inImage = false
  let inLex = false
  let lexMultiline = false

  let s = ''
  let last = ''
  let currText = ''
  let i = 0
  let resumeIndex = 0
  while (i < content.length) {
    let c = content[i]
    i += 1
    if (c == '`' && !inLex) {
      if (last.endsWith('``')) {
        if (inCode) {
          s += '</code></pre>'
          inCode = false
        } else {
          s += '<pre><code'
          inCode = true
          inCodeLang = true
          currText = ''
        }
      }
    } else if (inCodeLang) {
      if (c == ' ' || c == '\n') {
        if (currText) {
          s += ' class="language-' + currText + '">'
        } else {
          s += '>'
        }
        inCodeLang = false
        currText = ''
      } else if (currText.length > 32) {
        s += '>'
        inCodeLang = false
        currText = '' 
      } else {
        currText += c
      }
    } else if (c == '(' && last.endsWith('![IMG]') && !inImage) {  // markdown image
      inImage = true
      currText = '<img style="max-width:20rem;max-height:20rem;display:block" src="'
    } else if (inImage) {
      if (c == ')') {
        currText += '"/>'
        inImage = false
        s = s.slice(0, -6)
        s += currText
      } else if (c == ' ') {
        currText += '" title="'
      } else {
        currText += c
      }
    } else if (!inLex && !inCode && c == '$') {
      inLex = true
      currText = ''
      lexMultiline = false
      resumeIndex = i  // restart from here if exception
    } else if (inLex) {
      if (c == '$' && currText == '' && last.endsWith('$')) {
        lexMultiline = true
        resumeIndex = i
      } else if (!lexMultiline && c == '$' ) {
        inLex = false
        try { 
          s += katex.renderToString(currText, {strict: true})
        } catch {
          i = resumeIndex
          s += '$'
        }
      } else if (lexMultiline && c == '$' && last.endsWith('$')) {
        inLex = false
        try { 
          let ks = katex.renderToString(currText, {displayMode: true, strict: true})
          s += `<br>${ks}<br>`
        } catch {
          i = resumeIndex
          s += '$$'
        }
      } else if (c != '$') {
        currText += c
      }
    } else if (c == '&') {
      s += '&amp;'
    } else if (c == '<') {
      s += '&lt;'
    } else if (c == '>') {
      s += '&gt;'
    } else if (c == '"') {
      s += '&quot;'
    } else if (c == "'") {
      s += '&#039;'
    } else if (c == '\n' && !inCode) {
      if (!last.endsWith('\n') && !s.endsWith('</pre>')) s += '<br>'
    } else {
      s += c
    }

    if (i == content.length && inLex && currText) {
      try { 
        let ks = katex.renderToString(currText, {displayMode: lexMultiline, strict: true})
        s += lexMultiline ? `<br>${ks}<br>` : ks
      } catch { 
        inLex = false
        s += lexMultiline ? '$$' : '$'
        i = resumeIndex
      }
    }

    last += c
    if (last.length > 256) last = last.substr(last.length-128)
  }

  if (inCode) {
    if (inCodeLang) s += '>'
    s += '</code></pre>'
  }
  return s
}